import { OMNISEND_ACCOUNTS, OMNISEND_ACCOUNT } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class OmnisendController extends AuthenticatedController {
  static async getAccounts(facebookPageId: number) {
    return super.get(OMNISEND_ACCOUNTS, {
      facebook_page_id: facebookPageId,
    });
  }

  static async createAccessToken(facebookPageId: number, accessToken: string) {
    return super.post(OMNISEND_ACCOUNTS, { accessToken, facebookPageId });
  }

  static async updateAccessToken(
    facebookPageId: number,
    id: number,
    accessToken: string,
  ) {
    return super.put(OMNISEND_ACCOUNT(id), { accessToken, facebookPageId });
  }
}
